export default __webpack_public_path__ + "static/media/FOIL_BURNISH_120X278_002_265.a4fc4005.jpg";